<template>
  <div
    style="max-height: 87vh; overflow: auto;"
    class="expande-horizontal wrap pa-2"
  >
    <v-flex xs12>
      <div class="expande-horizontal">
        <v-list style="min-width: 100%;" width="100%" color="white">
          <v-list-item class="mx-0 px-2">
            <v-avatar class="mr-3" color="#333">
              <v-icon :color="$theme.primary"
                >mdi-chart-timeline-variant-shimmer</v-icon
              >
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <span class="fonte" style="font-size: 12pt !important;"
                  >Média geral</span
                >
              </v-list-item-title>
              <span>
                Veja abaixo a média geral de tempo de cada categoria
              </span>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn v-if="!generate" icon @click="generateReport">
                <v-icon color="green">mdi-printer</v-icon>
              </v-btn>
              <span small v-else icon @click="generate = !generate">
                Gerando...
              </span>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </div>
      <div class="expande-horizontal wrap">
        <v-progress-circular
          class="ma-1"
          color="orange"
          :value="90"
          dark
          striped
          width="12"
          size="170"
          :key="`c-${pc.category}`"
          v-for="pc in categoryAverage"
        >
          <div class="expande-horizontal centraliza column">
            <span class="black--text font-weight-bold fonte">Média:</span>
            <span class="fonte"
              ><v-icon size="21">mdi-clipboard-list-outline</v-icon>
              {{
                parseFloat((pc.evaluation_note || 0) / (pc.qtt || 0)).toFixed(2)
              }}</span
            >
            <span class="fonte"
              ><v-icon size="21">mdi-clipboard-clock-outline</v-icon>
              {{ pc.total_time_formatted }}</span
            >
            <v-divider></v-divider>
            <span
              class="fonte wrap text-center grey--text"
              style="width: 90px;"
              >{{ pc.category }}</span
            >
          </div>
        </v-progress-circular>
        <v-progress-circular
          class="ma-1"
          color="orange"
          :value="90"
          dark
          striped
          width="12"
          size="170"
        >
          <div class="expande-horizontal centraliza column">
            <span class="black--text font-weight-bold fonte">Média:</span>
            <span class="fonte">
              Esquerda: {{ dominancia_total.esquerda }}%
            </span>
            <span class="fonte">
              Direita: {{ dominancia_total.direita }}%
            </span>
            <!-- <span class="fonte"
              ><v-icon size="21">mdi-clipboard-clock-outline</v-icon>
              {{ pc.total_time_formatted }}</span
            > -->
            <v-divider></v-divider>
            <span class="fonte wrap text-center grey--text" style="width: 90px;"
              >Dominância Leteral</span
            >
          </div>
        </v-progress-circular>
      </div>
      <v-simple-table v-if="false" dense>
        <template v-slot:default>
          <thead>
            <tr style="background: #f2f2f2;">
              <th class="fonte">CATEGORIA</th>
              <th class="fonte">INSTRUÇÃO</th>
              <th class="fonte">NOTA MÉDIA</th>
              <th class="fonte">TEMPO MÉDIO</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="fonte font-weight-bold">Média geral</td>
              <td class="fonte">- -</td>
              <td class="fonte">- -</td>
              <td class="fonte">{{ mediaGeneralTime }}</td>
            </tr>
            <tr
              v-for="(_step, index) in timeAverage"
              :key="`step-result-${_step.step}`"
            >
              <td class="fonte">{{ _step.category }}</td>
              <td class="fonte">{{ _step.task }}</td>
              <td class="fonte">{{ _step.average_note }}</td>
              <td class="fonte">{{ _step.total_step_time_formatted }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-flex xs12>
        <div class="expande-horizontal">
          <v-list style="min-width: 100%;" width="100%" color="white">
            <v-list-item class="mx-0 px-2">
              <v-avatar class="mr-3" color="#333">
                <v-icon :color="$theme.primary">mdi-file-chart</v-icon>
              </v-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="fonte" style="font-size: 12pt !important;"
                    >Avaliações</span
                  >
                </v-list-item-title>
                <v-list-item-subtitle>
                  Veja abaixo as avaliações que foram analisadas para o
                  relatório
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </v-flex>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr style="background: #f2f2f2;">
              <th class="fonte">NOME DO AVALIADO</th>
              <th class="fonte">IDADE</th>
              <th class="fonte">CARACTERÍSTICAS IMPORTANTES</th>
              <th class="fonte">DOMINÂNCIA LATERAL PRED.</th>
              <th class="fonte">SCORE MÉDIO</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(_step, index) in filtereds"
              :key="`step-contabilized-${index}`"
            >
              <td class="fonte">{{ _step.student.nome }}</td>
              <td class="fonte">{{ _step.student.idade }}</td>
              <td class="fonte">{{ _step.student.obs }}</td>
              <td class="fonte">{{ _step | dominancia }}</td>
              <td class="fonte">{{ _step | score }}</td>
              <!-- <td class="fonte">{{ _step.time_total | formattedTime }}</td> -->
              <!-- <td class="fonte">{{ $moment(_step.created_at).format('DD/MM [às] HH:mm') }}</td> -->
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-flex>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      filename="Relatório"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      @ended="generate = false"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <section class="pdf-item">
          <v-flex class="pa-3" xs12>
            <div class="expande-horizontal">
              <v-list style="min-width: 100%;" width="100%" color="white">
                <v-list-item class="mx-0 px-2">
                  <v-avatar class="mr-3" color="#333">
                    <v-icon :color="$theme.primary"
                      >mdi-chart-timeline-variant-shimmer</v-icon
                    >
                  </v-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="fonte" style="font-size: 12pt !important;"
                        >Média geral</span
                      >
                    </v-list-item-title>
                    <!-- <span>
                      Veja abaixo a média geral de tempo de cada categoria
                    </span> -->
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
            <div class="expande-horizontal">
              <div
                class="ma-1 expande-horizontal centraliza"
                style="width: 200px; height: 200px; border-radius: 50%; border: 5px solid #333; justify-content: center; align-items: center;"
                :key="`cs-${pc.category}`"
                v-for="pc in categoryAverage"
              >
                <div class="expande-horizontal centraliza column">
                  <span class="black--text font-weight-bold fonte" style="color: #333 !important;">Média:</span>
                  <span style="color: #333 !important;" class="fonte"
                    ><v-icon size="21">mdi-clipboard-list-outline</v-icon>
                    {{
                      parseFloat(
                        (pc.evaluation_note || 0) / (pc.qtt || 0)
                      ).toFixed(2)
                    }}</span
                  >
                  <span class="fonte"
                    style="color: #333 !important;"
                    ><v-icon size="21">mdi-clipboard-clock-outline</v-icon>
                    {{ pc.total_time_formatted }}</span
                  >
                  <v-divider></v-divider>
                  <span
                    class="fonte wrap text-center grey--text"
                    style="width: 90px; text-align: center; color: #333 !important;"
                    >{{ pc.category }}</span
                  >
                </div>
              </div>
              <div
                class="ma-1 expande-horizontal centraliza"
                style="width: 200px; height: 200px; border-radius: 50%; border: 5px solid #333; justify-content: center; align-items: center;"
              >
                <div class="expande-horizontal centraliza column">
                  <span class="black--text font-weight-bold fonte" style="color: #333 !important;">Média:</span>
                  <span class="fonte" style="color: #333 !important;">
                    Esquerda: {{ dominancia_total.esquerda }}%
                  </span>
                  <span class="fonte" style="color: #333 !important;">
                    Direita: {{ dominancia_total.direita }}%
                  </span>
                  <!-- <span class="fonte"
              ><v-icon size="21">mdi-clipboard-clock-outline</v-icon>
              {{ pc.total_time_formatted }}</span
            > -->
                  <v-divider></v-divider>
                  <span
                    class="fonte wrap text-center grey--text"
                    style="width: 90px;width: 90px; text-align: center; color: #333 !important;"
                    >Dominância Leteral</span
                  >
                </div>
              </div>
            </div>
            <v-flex xs12>
              <div class="expande-horizontal">
                <v-list style="min-width: 100%;" width="100%" color="white">
                  <v-list-item class="mx-0 px-2">
                    <v-avatar class="mr-3" color="#333">
                      <v-icon :color="$theme.primary">mdi-file-chart</v-icon>
                    </v-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        <span class="fonte" style="font-size: 12pt !important;"
                          >Avaliações</span
                        >
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Veja abaixo as avaliações que foram analisadas para o
                        relatório
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-flex>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr style="background: #f2f2f2;">
                    <th class="fonte">NOME DO AVALIADO</th>
                    <th class="fonte">IDADE</th>
                    <th class="fonte">CARACTERÍSTICAS IMPORTANTES</th>
                    <th class="fonte">DOMINÂNCIA LATERAL PRED.</th>
                    <th class="fonte">SCORE MÉDIO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(_step, index) in filtereds"
                    :key="`step-contabilized-${index}`"
                  >
                    <td class="fonte">{{ _step.student.nome }}</td>
                    <td class="fonte">{{ _step.student.idade }}</td>
                    <td class="fonte">{{ _step.student.obs }}</td>
                    <td class="fonte">{{ _step | dominancia }}</td>
                    <td class="fonte">{{ _step | score }}</td>
                    <!-- <td class="fonte">{{ _step.time_total | formattedTime }}</td> -->
                    <!-- <td class="fonte">{{ $moment(_step.created_at).format('DD/MM [às] HH:mm') }}</td> -->
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            
          </v-flex>
        </section>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
export default {
  data() {
    return {
      generate: false
    };
  },
  components: {
    VueHtml2pdf
  },
  props: {
    filtereds: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    formattedTime(value) {
      const minutes = Math.floor(value / 60);
      const seconds = value % 60;
      return `${minutes}m ${seconds}s`;
    },
    dominancia(value) {
      let right = 0;
      let left = 0;
      if (value.steps) {
        value.steps.map(i => {
          if (!i.member) return;
          if (i.member == "esquerdo") {
            left += 1;
          } else if (i.member == "direito") {
            right += 1;
          }
        });
      } else {
        return "";
      }
      if (left > right) {
        return "esquerdo";
      }
      if (right > left) {
        return "direito";
      }
      if (right == left) {
        return "empate";
      }
    },

    score(value) {
      let total = 0;
      if (value) {
        value.steps.map(i => {
          total += i.evaluation_note;
        });
        let res = total / value.steps.length;
        return `${res.toFixed(2)}`;
      }
    }
  },
  methods: {
    generateReport() {
      this.generate = true;
      setTimeout(() => {
        this.$refs.html2Pdf.generatePdf();
      }, 300);
    },
    onProgress(progress) {
      console.log(progress);
    },
    hasStartedGeneration() {
      console.log("hasStartedGeneration");
    },
    hasGenerated(pdfData) {
      this.generate = false;
      console.log("hasGenerated");
      console.log(pdfData);
    }
  },
  computed: {
    dominancia_total() {
      let left = 0;
      let right = 0;
      this.filtereds.map(i => {
        i.steps.map(step => {
          if (!step.member) return;
          if (step.member == "esquerdo") {
            left += 1;
          } else if (step.member == "direito") {
            right += 1;
          }
        });
      });
      let percent_left = (left / (left + right)) * 100;
      let percent_right = (right / (left + right)) * 100;
      return {
        esquerda: percent_left.toFixed(2),
        direita: percent_right.toFixed(2)
      };
    },
    mediaGeneralTime() {
      let media = 0;
      this.filtereds.forEach(evaluation => {
        media += evaluation.time_total;
      });
      const value = media / this.filtereds.length;
      const minutes = Math.floor(value / 60);
      const seconds = value % 60;
      return `${minutes}m ${seconds}s`;
    },
    categoryAverage() {
      let categories = [
        "Destreza Manual",
        "Habilidades com a bola",
        "Equilíbrio estático",
        "Óculo manual"
      ];

      let categoriesProcessed = [];

      categories.map(c => {
        let category = {
          category: c,
          evaluation_note: 0,
          total_step_time: 0,
          qtt: 0
        };
        this.timeAverage.map(ta => {
          if (ta.category === c) {
            category.evaluation_note += ta.average_note;
            category.total_step_time += ta.total_step_time;
            category.qtt += ta.qtt;
          }
        });
        const mediaTime =
          (category.total_step_time && category.total_step_time
            ? category.total_step_time
            : 0) / (category.qtt ? category.qtt : 0);
        const minutes = Math.floor(mediaTime / 60);
        const seconds = parseInt(mediaTime % 60);
        const formattedTime =
          (minutes < 10 ? "0" : "") +
          minutes +
          ":" +
          (seconds < 10 ? "0" : "") +
          seconds;
        category.total_time_formatted = formattedTime;
        categoriesProcessed.push(category);
      });
      return categoriesProcessed;
    },
    timeAverage() {
      const timeAverage = [];
      this.filtereds.forEach(evaluation => {
        if (!evaluation.steps) return;
        evaluation.steps.forEach(step => {
          const index = timeAverage.findIndex(item => item.step === step.step);
          if (index === -1) {
            timeAverage.push({
              qtt: 1,
              step: step.step,
              category: step.category,
              task: step.task,
              evaluation_note: step.evaluation_note,
              average_note: parseInt(step.evaluation_note),
              total_step_time: step.total_step_time,
              total_step_time_formatted: step.total_step_time_formatted
            });
          } else {
            timeAverage[index].total_step_time += step.total_step_time;
            timeAverage[index].average_note += step.evaluation_note;
            timeAverage[index].qtt += 1;
          }
        });
      });
      return timeAverage;
    }
    // showFiltereds() {
    //   return this.filtereds.slice(0, this.itemsToShow);
    // }
  }
};
</script>
